import React, { createContext, useReducer } from 'react';
import { useUserContext } from './UserContext';

// Объект контекста
export const ArchiveContext = createContext({});
// Начальное состояние задач
const initialState = {
  archive: [], // Массив задач
//   filterBy: '', // Текущий фильтр (статус или другое условие)
  hostname: process.env.REACT_APP_API_URL || "" //process.env.REACT_APP_API_URL
};

// Редюсер для изменения состояния задач
const archiveReducer = (state, action) => {
  switch (action.type) {
    
    case 'DELETE_ARCHIVE':
      return {
        ...state,
        archive: state.archive.filter(archive => archive._id !== action.payload.id),
      };
      case 'UPDATE_ARCHIVE':
      return {
        ...state,
        archive: state.archive.map(task => {
          if (task._id === action.payload.id) {
            action.payload.updatedTask.creator = task.creator
            action.payload.updatedTask.createDate = task.createDate
          }
         return task._id === action.payload.id ? action.payload.updatedTask : task
        }
        ),
      };
    case 'RETURN_ARCHIVE':
      return {
        ...state,
        archive: state.archive.filter(archive => archive._id !== action.payload.id),
        // filterBy: action.payload.filterValue,
      };
    case 'GET_ARCHIVE':
      return {
        ...state,
        archive: action.payload.archive,
      };
    default:
      return state;
  }
};

// Экспорт самого контекста
export default ArchiveContext;
export const ArchiveProvider = ({ children }) => {
  const [state, dispatch] = useReducer(archiveReducer, initialState);
const {logout} = useUserContext();
  // Методы для манипуляции задачами
  
  const deleteArchive = async id => {
     try {
      const response = await fetch(initialState.hostname+'/archive/archive/'+ id, {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        }
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
        dispatch({ type: 'DELETE_ARCHIVE', payload: { id } });
        return data;
    } catch (error) {
      console.log(error);
    }
  };

  const updateArchive = async (task, id) => {
    try{
      dispatch({
              type: 'UPDATE_ARCHIVE',
              payload: { updatedTask: task, id: id },
            });
    }
    catch(error){

    }
  }

   const returnArchive = async (credentials, id) => {
    try{
    const response = await fetch(initialState.hostname+'/archive/return/' + id, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        },
        body: JSON.stringify(credentials)
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
      if (data.success) {

        dispatch({
              type: 'RETURN_ARCHIVE',
              payload: { id: id },
            });
      
        
      }
    
    } catch (err) {
      console.error(err);
    }
  };

  const fetchArchive = async () => {
    try {
      const response = await fetch(initialState.hostname+'/archive/getArchive', {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        }
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
        dispatch({ type: 'GET_ARCHIVE', payload: { archive: data.data } });
        return data;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <ArchiveContext.Provider value={{
      archive: state.archive,
    //   filterBy: state.filterBy,
    updateArchive,
      deleteArchive,
      returnArchive,
      fetchArchive,
    }}>
      {children}
    </ArchiveContext.Provider>
  );
};
export const useArchiveContext = () => {
  const context = React.useContext(ArchiveContext);
  if (!context) throw new Error("useTaskContext must be used within a UserProvider");
  return context;
};